var vehicle = {};
module["exports"] = vehicle;
vehicle.fuel = require("./fuel");
vehicle.manufacturer = require("./manufacturer");
vehicle.module = require("./model");
vehicle.type = require("./vehicle_type");